import ObjectUtils from "@/modules/Object/ObjectUtils";
import { Commit } from "vuex";
import { ForexTemplateState } from "@/feature/Forex/store/template/interface";
import { ForexTemplateFilter, ForexTemplateWithDraft } from "@/feature/Forex/api/template/forex-template.interface";
import { ForexTemplateMutation } from "@/feature/Forex/store/template/constants";
import { forexFormRequestFields } from "@/feature/Forex/models/forex-form-request-fields";

export const getTemplateFilter = (
	state: ForexTemplateState
): ForexTemplateFilter => ObjectUtils.excludeEmpty({
	pageNumber: state.pageNumber,
	elementsOnPage: state.pageSize
});

export const getTemplateNextPageFilters = (
	state: ForexTemplateState,
	commit: Commit
): ForexTemplateFilter => {
	if (!state.isEndPage)
		commit(ForexTemplateMutation.setNextPage);

	return getTemplateFilter(state);
};

export const getTemplateCreateDTO = (
	template?: ForexTemplateWithDraft
): ForexTemplateWithDraft => ObjectUtils.excludeEmpty(
	ObjectUtils.includeKeys(
		ObjectUtils.deepCopy(template)!,
		forexFormRequestFields as (keyof ForexTemplateWithDraft)[]
	)
) as ForexTemplateWithDraft;